import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import creditRequestListAction from './creditRequestList.action.json' with { type: 'json' }
import { creditRequestObject } from '../creditRequestObject'

export const creditRequestExpression = expression(creditRequestObject.shape)

const creditRequestListDefinition = defineAction({
  ...creditRequestListAction,

  input: z.object({
    filter: creditRequestExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      code: 'Número',
      requestDate: 'Data do requerimento',
      totalMovementValue: 'Valor total do movimento',
      estimatedBonusValue: 'Valor previsto',
      status: 'Status',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(creditRequestObject),
    count: z.number(),
  }),
})

export default creditRequestListDefinition

